import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./ProjectSlider.css";

function ProjectSlider() {
  const [projects, setProjects] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const API_BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/projects`);
        if (!response.ok) throw new Error("Failed to fetch projects");
        const data = await response.json();
        console.log("Fetched projects:", data);
        setProjects(data);
      } catch (err) {
        console.error("Error fetching projects:", err);
      }
    };
    fetchProjects();
  }, [API_BASE_URL]);

  
  useEffect(() => {
    if (!projects || projects.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === projects.length - 1 ? 0 : prevIndex + 1
      );
    }, 10000); 

    return () => clearInterval(interval); 
  }, [projects]);

  if (!projects || projects.length === 0) return <p>Proje bulunamadı.</p>;

  const currentProject = projects[currentIndex];
  const imageUrl =
    currentProject?.images?.length > 0 ? currentProject.images[0] : null;

  return (
    <div className="slider-container">
      {/* Previous Button */}
      <button
        className="slider-button"
        onClick={() =>
          setCurrentIndex(
            currentIndex === 0 ? projects.length - 1 : currentIndex - 1
          )
        }
      >
        ‹
      </button>

      {/* Slider Content */}
      <div className="slider-content">
        <Link to="/projects" className="image-text-wrapper">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={currentProject.title}
              className="slider-image"
            />
          ) : (
            <div className="no-image-placeholder">Resim yok</div>
          )}
          <div className="text-overlay">
            <h3>{currentProject.title}</h3>
          </div>
        </Link>
      </div>

      {/* Next Button */}
      <button
        className="slider-button"
        onClick={() =>
          setCurrentIndex(
            currentIndex === projects.length - 1 ? 0 : currentIndex + 1
          )
        }
      >
        ›
      </button>
    </div>
  );
}

export default ProjectSlider;
